<div class="join-us-container mat-elevation-z2" id="joinUs">
  <div fxLayout="row wrap">
    <div
      fxFlex.gt-sm="50"
      fxFlex.lt-sm="0"
      class="join"
      style="
        background: url(/assets/for-merchant-overlay_flipped.png),
          url(/assets/bg/for-shoppers.jpg),
          url(/assets/for-merchant-overlay_flipped.png);
        background-size: cover;
        overflow: hidden;
      "
    ></div>
    <div fxFlex.gt-sm="50" fxFlex.lt-sm="100" class="row-container">
      <div class="content" style="text-align: center; padding: 0">
        <h1 class="Join-title">
          Simple shopping with <br />
          <span>3 x Zero fee, Zero interest </span><br />payments.
        </h1>
        <br />
        <p class="info-paragraph">
          Whether its a big purchase or small purchase, ZeroPay makes your
          payments more convenient. Plus your order is shipped right away.
        </p>
        <br />
        <p class="content-payment">
          <span>1<sup>st </sup>payment:</span> Immediately.
        </p>
        <p class="content-payment">
          <span>2<sup>nd </sup>payment:</span> Payday.
        </p>
        <p class="content-payment">
          <span>3<sup>rd </sup>payment:</span> Next payday.
        </p>
        <br />
        <a
          class="header-action"
          mat-stroked-button
          [href]="redirect"
          target="_blank"
          >APPLY NOW</a
        >
      </div>
    </div>
  </div>
</div>
<div class="how-it-works" id="howItWorks">
  <div class="content">
    <h1>How it works</h1>
    <br />
    <p>Shop what you want, way easier, with ZeroPay</p>
    <a mat-stroked-button [href]="redirect" target="_blank" class="btn-action"
      >APPLY NOW</a
    >
    <div fxLayout="row wrap" class="steps">
      <div fxFlex.gt-sm="33.33" fxFlex.lt-sm="100" class="how-it-works-step">
        <!-- <img src="/assets/final/get-it.png" /> -->
        <img src="/assets/icons/1.png" />
        <h2>get it.</h2>
        <p class="info-paragraph">
          Apply for your ZeroPay account by following the quick and easy steps.
          Be approved in less than a minute.
        </p>
      </div>
      <div fxFlex.gt-sm="33.33" fxFlex.lt-sm="100" class="how-it-works-step">
        <!-- <img src="/assets/final/got-it.png" /> -->
        <img src="/assets/icons/2.png" />
        <h2>got it.</h2>
        <p class="info-paragraph">
          Select ZeroPay as your preferred secure payment option at any one of
          our shopping partners.
        </p>
      </div>
      <div fxFlex.gt-sm="33.33" fxFlex.lt-sm="100" class="how-it-works-step">
        <!-- <img src="/assets/final/good.png" /> -->
        <img src="/assets/icons/3.png" />
        <h2>good.</h2>
        <p class="info-paragraph">
          Pay for your shopping in 3 x
          <span> Zero fees, Zero interest</span> payments. Your order is shipped
          right away.
        </p>
      </div>
    </div>
  </div>
</div>
<app-payment-explanation></app-payment-explanation>
<!-- <app-spend-limit></app-spend-limit> -->
<div class="faq" id="howItWorks">
  <div class="content">
    <h1>Got a question?</h1>
    <br />
    <p>
      Read through our Frequently Asked Questions - you might just find what you
      are looking for.
    </p>
    <a
      mat-stroked-button
      [routerLink]="['/shopper-faq']"
      (click)="scrollTo('top')"
      class="btn-action"
      >READ MORE</a
    >
    <br />
    <!-- <a mat-stroked-button  [href]="redirect" target="_blank" class="get-shopping">Get Shopping!</a> -->
  </div>
</div>
